import CityPageTemplate from "../city-template/CityPageTemplate";
import { inclineVillageConfig } from "./data";

export default function InclineVillagePage() {
  return <CityPageTemplate config={inclineVillageConfig} />;
}